import {
  titleUI,
  descriptionUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { ExposureCategoriesLink } from '../../../../components/FormDescriptions/OtherExposureDescriptions';
import { FULL_SCHEMA } from '../../../../utils/imports';
import content from '../../../../locales/en/content.json';

const TITLE_TEXT = content['service-info--exposures-title'];
const DESC_TEXT = content['service-info--other-exposures-description'];
const INPUT_LABEL = content['service-info--other-exposures-label'];
const ERR_MSGS = {
  pattern: content['validation-error--other-exposures'],
};

const { otherToxicExposure } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(ExposureCategoriesLink),
    otherToxicExposure: textUI({
      title: INPUT_LABEL,
      errorMessages: ERR_MSGS,
    }),
  },
  schema: {
    type: 'object',
    properties: { otherToxicExposure },
  },
};
